export const ClockWarn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      stroke="#525866"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8.503 4v4l2.666 1.334m4-1.333A6.667 6.667 0 1 1 1.836 8a6.667 6.667 0 0 1 13.333 0"
    />
  </svg>
);
